module.exports = __webpack_public_path__ + "static/media/LoginIcon.780948b4.png";